import { YourLessonsApi } from "@/api";

export async function getYourLessons(semester) {
  const { data } = await YourLessonsApi.getYourLessons(semester);
  return data;
}
